<template>
  <div class="page-faq">
    <div class="st-card">
      <div
        class="st-card-glow"
        aria-hidden="true"
      />
      <div class="st-head">
        <span class="st-icon">
          <feather-icon
            icon="HelpCircleIcon"
            size="20"
          />
        </span>
        <h2 class="st-title">
          {{ $t('F.A.Q.') }}
        </h2>
      </div>

      <div class="faq-list">
        <div
          v-for="(faq, index) in faqs"
          :key="'faq-' + index"
          class="faq-item"
          :class="{ open: openIndex === index }"
        >
          <button
            type="button"
            class="faq-question"
            :aria-expanded="openIndex === index ? 'true' : 'false'"
            @click="toggle(index)"
          >
            <span>{{ faq.q }}</span>
            <feather-icon
              icon="ChevronDownIcon"
              size="18"
              class="faq-chevron"
            />
          </button>
          <div
            v-show="openIndex === index"
            class="faq-answer"
            v-html="faq.a"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'settings.faq',
  data() {
    return {
      openIndex: 0,
    }
  },
  computed: {
    // Çeviri dosyalarında SSS "pages.faqs[0].q" / "pages.faqs[0].a" şeklinde düz anahtarlar olarak duruyor;
    // $t('pages.faqs') bir liste döndürmediği için listeyi buradan kuruyoruz.
    faqs() {
      const list = []
      for (let i = 0; i < 100; i += 1) {
        const qKey = `pages.faqs[${i}].q`
        if (!this.$te(qKey) && !this.$te(qKey, 'en')) break
        list.push({
          q: this.$t(qKey),
          a: this.$t(`pages.faqs[${i}].a`),
        })
      }
      return list
    },
  },
  methods: {
    toggle(index) {
      this.openIndex = this.openIndex === index ? null : index
    },
  },
}
</script>

<style lang="scss" scoped>
.page-faq {
  margin: 0 -25px;
}

.st-card {
  position: relative;
  overflow: hidden;
  background: rgba(32, 22, 72, 0.72);
  border: 1px solid rgba(150, 110, 255, 0.28);
  border-radius: 20px;
  box-shadow: 0 12px 40px rgba(6, 2, 24, 0.45);
  padding: 26px 30px 30px;

  @media (max-width: 575px) { padding: 20px 16px; }
}

.st-card-glow {
  position: absolute;
  top: -60px;
  right: -60px;
  width: 280px;
  height: 280px;
  background: radial-gradient(circle, rgba(234, 3, 178, 0.25), transparent 70%);
  pointer-events: none;
}

.st-head {
  position: relative;
  display: flex;
  align-items: center;
  gap: 14px;
  padding-bottom: 18px;
  margin-bottom: 20px;
  border-bottom: 1px solid rgba(150, 110, 255, 0.2);
}

.st-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: linear-gradient(135deg, #8b5cf6, #a855f7);
  flex-shrink: 0;
}

.st-title {
  color: #fff !important;
  font-size: 22px;
  font-weight: 700;
  margin: 0;
}

.faq-list {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 900px;
}

.faq-item {
  border-radius: 14px;
  background: rgba(14, 10, 40, 0.45);
  border: 1px solid rgba(150, 110, 255, 0.2);
  transition: border-color .2s ease, background .2s ease;

  &.open {
    background: linear-gradient(135deg, rgba(234, 3, 178, 0.14) 0%, rgba(168, 85, 247, 0.12) 50%, rgba(99, 102, 241, 0.06) 100%);
    border-color: rgba(234, 3, 178, 0.35);

    .faq-chevron { transform: rotate(180deg); color: #f472b6; }
  }
}

.faq-question {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 15px 18px;
  border: 0;
  background: transparent;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  text-align: left;
  cursor: pointer;

  .faq-chevron {
    flex-shrink: 0;
    color: rgba(226, 220, 255, 0.7);
    transition: transform .2s ease;
  }
}

.faq-answer {
  padding: 0 18px 16px;
  color: rgba(236, 232, 255, 0.85);
  font-size: 14px;
  line-height: 1.7;

  ::v-deep p { margin-bottom: 8px; }
  ::v-deep a { color: #f472b6; }
}
</style>
